import { loadedAsESV } from "@mirage/shared/util/esv";
import { RoutePath } from "@mirage/webapp/routeTypes";
import { useNavigate } from "react-router-dom";

export const EmbedLauncherPage: React.FC = () => {
  const navigate = useNavigate();
  const isESV = loadedAsESV();

  if (!isESV) {
    navigate(RoutePath.NOT_FOUND);
    return null;
  }

  return (
    <div style={{ backgroundColor: "black", color: "white" }}>
      EmbedLauncherPage
    </div>
  );
};
